/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\genclient.json
 */

"use strict";

import Contracts = require("VSS/FileContainer/Contracts");
import VSS_Common_Contracts = require("VSS/WebApi/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods2To7_2 extends VSS_WebApi.VssHttpClient {
    protected containersApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API] Gets the specified file container object in a format dependent upon the given parameters or HTTP Accept request header
     *
     * @param {number} containerId - The requested container Id
     * @param {string} scope - A guid representing the scope of the container. This is often the project id.
     * @param {string} itemPath - The path to the item of interest
     * @param {boolean} metadata - If true, this overrides any specified format parameter or HTTP Accept request header to provide non-recursive information for the given itemPath
     * @param {string} format - If specified, this overrides the HTTP Accept request header to return either 'json' or 'zip'.  If $format is specified, then api-version should also be specified as a query parameter.
     * @param {string} downloadFileName - If specified and returning other than JSON format, then this download name will be used (else defaults to itemPath)
     * @param {boolean} includeDownloadTickets
     * @param {boolean} isShallow - If true, returns only immediate children(files & folders) for the given itemPath. False will return all items recursively within itemPath.
     * @param {boolean} ignoreRequestedMediaType - Set to true to ignore the HTTP Accept request header. Default is false.
     * @param {boolean} includeBlobMetadata
     * @param {boolean} saveAbsolutePath - Set to false to not save the absolute path to the specified directory of the artifact in the returned archive. Works only for artifact directories. Default is true.
     * @param {boolean} preferRedirect - Set to true to get the redirect response which leads to the stream with content. Default is false.
     * @return IPromise<Contracts.FileContainerItem[]>
     */
    public getItems(
        containerId: number,
        scope?: string,
        itemPath?: string,
        metadata?: boolean,
        format?: string,
        downloadFileName?: string,
        includeDownloadTickets?: boolean,
        isShallow?: boolean,
        ignoreRequestedMediaType?: boolean,
        includeBlobMetadata?: boolean,
        saveAbsolutePath?: boolean,
        preferRedirect?: boolean
        ): IPromise<Contracts.FileContainerItem[]> {

        const queryValues: any = {
            scope: scope,
            itemPath: itemPath,
            metadata: metadata,
            '$format': format,
            downloadFileName: downloadFileName,
            includeDownloadTickets: includeDownloadTickets,
            isShallow: isShallow,
            ignoreRequestedMediaType: ignoreRequestedMediaType,
            includeBlobMetadata: includeBlobMetadata,
            saveAbsolutePath: saveAbsolutePath,
            preferRedirect: preferRedirect
        };

        return this._beginRequest<Contracts.FileContainerItem[]>({
            httpMethod: "GET",
            area: "Container",
            locationId: "e4f5c81e-e250-447b-9fef-bd48471bea5e",
            resource: "Containers",
            routeTemplate: "_apis/resources/{resource}/{containerId}/{*itemPath}",
            responseType: Contracts.TypeInfo.FileContainerItem,
            responseIsCollection: true,
            routeValues: {
                containerId: containerId
            },
            queryParams: queryValues,
            apiVersion: this.containersApiVersion
        });
    }

    /**
     * [Preview API] Gets containers filtered by a comma separated list of artifact uris within the same scope, if not specified returns all containers
     *
     * @param {string} scope - A guid representing the scope of the container. This is often the project id.
     * @param {string} artifactUris
     * @return IPromise<Contracts.FileContainer[]>
     */
    public getContainers(
        scope?: string,
        artifactUris?: string
        ): IPromise<Contracts.FileContainer[]> {

        const queryValues: any = {
            scope: scope,
            artifactUris: artifactUris
        };

        return this._beginRequest<Contracts.FileContainer[]>({
            httpMethod: "GET",
            area: "Container",
            locationId: "e4f5c81e-e250-447b-9fef-bd48471bea5e",
            resource: "Containers",
            routeTemplate: "_apis/resources/{resource}/{containerId}/{*itemPath}",
            responseType: Contracts.TypeInfo.FileContainer,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.containersApiVersion
        });
    }

    /**
     * [Preview API] Deletes the specified items in a container.
     *
     * @param {number} containerId - Container Id.
     * @param {string} itemPath - Path to delete.
     * @param {string} scope - A guid representing the scope of the container. This is often the project id.
     * @return IPromise<void>
     */
    public deleteItem(
        containerId: number,
        itemPath: string,
        scope?: string
        ): IPromise<void> {

        const queryValues: any = {
            itemPath: itemPath,
            scope: scope
        };

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Container",
            locationId: "e4f5c81e-e250-447b-9fef-bd48471bea5e",
            resource: "Containers",
            routeTemplate: "_apis/resources/{resource}/{containerId}/{*itemPath}",
            routeValues: {
                containerId: containerId
            },
            queryParams: queryValues,
            apiVersion: this.containersApiVersion
        });
    }

    /**
     * [Preview API] Creates the specified items in the referenced container.
     *
     * @param {VSS_Common_Contracts.VssJsonCollectionWrapperV<Contracts.FileContainerItem[]>} items
     * @param {number} containerId
     * @param {string} scope - A guid representing the scope of the container. This is often the project id.
     * @return IPromise<Contracts.FileContainerItem[]>
     */
    public createItems(
        items: VSS_Common_Contracts.VssJsonCollectionWrapperV<Contracts.FileContainerItem[]>,
        containerId: number,
        scope?: string
        ): IPromise<Contracts.FileContainerItem[]> {

        const queryValues: any = {
            scope: scope
        };

        return this._beginRequest<Contracts.FileContainerItem[]>({
            httpMethod: "POST",
            area: "Container",
            locationId: "e4f5c81e-e250-447b-9fef-bd48471bea5e",
            resource: "Containers",
            routeTemplate: "_apis/resources/{resource}/{containerId}/{*itemPath}",
            responseType: Contracts.TypeInfo.FileContainerItem,
            responseIsCollection: true,
            routeValues: {
                containerId: containerId
            },
            queryParams: queryValues,
            apiVersion: this.containersApiVersion,
            data: items
        });
    }

    /**
     * [Preview API] Creates the specified item in the container referenced container.
     *
     * @param {string} content - Content to upload
     * @param {number} containerId
     * @param {string} itemPath
     * @param {string} scope - A guid representing the scope of the container. This is often the project id.
     * @param {string} artifactHash
     * @param {number} fileLength
     * @return IPromise<Contracts.FileContainerItem>
     */
    public createItem(
        content: string,
        containerId: number,
        itemPath: string,
        scope?: string,
        artifactHash?: string,
        fileLength?: number
        ): IPromise<Contracts.FileContainerItem> {

        const queryValues: any = {
            itemPath: itemPath,
            scope: scope,
            artifactHash: artifactHash,
            fileLength: fileLength
        };

        return this._beginRequest<Contracts.FileContainerItem>({
            httpMethod: "PUT",
            area: "Container",
            locationId: "e4f5c81e-e250-447b-9fef-bd48471bea5e",
            resource: "Containers",
            routeTemplate: "_apis/resources/{resource}/{containerId}/{*itemPath}",
            responseType: Contracts.TypeInfo.FileContainerItem,
            routeValues: {
                containerId: containerId
            },
            customHeaders: {
                "Content-Type": "application/octet-stream",
            },
            queryParams: queryValues,
            apiVersion: this.containersApiVersion,
            data: content
        });
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient7_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "7.2-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient7_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "7.1-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient7 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "7.0-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient6_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "6.1-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient6 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "6.0-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient5_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "5.2-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient5_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "5.1-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient5 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "5.0-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient4_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "4.1-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient4 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "4.0-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient3_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "3.2-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient3_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "3.1-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "3.0-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient2_3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "2.3-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient2_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "2.2-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient2_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "2.1-preview.4";
    }
}

/**
 * @exemptedapi
 */
export class FileContainerHttpClient2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.containersApiVersion = "2.0-preview.4";
    }
}

export class FileContainerHttpClient extends FileContainerHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": FileContainerHttpClient7_2,
    "7.1": FileContainerHttpClient7_1,
    "7.0": FileContainerHttpClient7,
    "6.1": FileContainerHttpClient6_1,
    "6.0": FileContainerHttpClient6,
    "5.2": FileContainerHttpClient5_2,
    "5.1": FileContainerHttpClient5_1,
    "5.0": FileContainerHttpClient5,
    "4.1": FileContainerHttpClient4_1,
    "4.0": FileContainerHttpClient4,
    "3.2": FileContainerHttpClient3_2,
    "3.1": FileContainerHttpClient3_1,
    "3.0": FileContainerHttpClient3,
    "2.3": FileContainerHttpClient2_3,
    "2.2": FileContainerHttpClient2_2,
    "2.1": FileContainerHttpClient2_1,
    "2.0": FileContainerHttpClient2
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return FileContainerHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): FileContainerHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<FileContainerHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<FileContainerHttpClient7_1>(FileContainerHttpClient7_1, undefined, undefined, undefined, options);
    }
}
